module.exports = __webpack_public_path__ + "img/calendar.f60ffaee.svg";